import { Injectable } from '@angular/core';
import { interval, timer } from 'rxjs';

@Injectable()
export class GlobalJobSchedulerService {

  private timer = timer(5 * 60 * 1000, 5 * 60 * 1000);
  private jobs: RepeatableJob[] = [];

  constructor() {
    this.timer.subscribe(() => {
      this.jobs.forEach(x => {
        if(x.jobAction) {
          x.jobAction();
        }
      });
    });
  }

  addJob(job: RepeatableJob): void {
    this.jobs.push(job);
  }

  removeJob(job: RepeatableJob): void {
    const idx = this.jobs.indexOf(job);
    this.jobs.splice(idx, 1);
  }
}

export interface RepeatableJob {
  jobName?: string;
  jobAction?: () => void;
}
